import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostJiraStatusesRequest = {
	customerId: number;
	jiraStatusId: string;
	initiativeStatusId: number;
};

export const postJiraStatuses = createPostEndpoint<PostJiraStatusesRequest>('/api/v3/jira/statuses');
